import { Component } from '@angular/core';

@Component({
  selector: 'app-grocy-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class GrocyDashboardComponent {}
